import UsersTable from "./UsersTable";

export default function SuperAdmin() {
  return <UsersTable type="admin" />;
}
